import script from "./ModalOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalOverlay.vue?vue&type=script&setup=true&lang=js"

import "./ModalOverlay.vue?vue&type=style&index=0&id=788b82b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788b82b5"]])

export default __exports__